<script setup>
import Popup from './gridpopup.vue';
import { $vfm, VueFinalModal, ModalsContainer } from 'vue-final-modal';
</script>

<script>
export default {
  components: {
      Popup,
   },
  data: () => ({
    popupshow: false,
    clientID : "",
    OxygenNumber:"",
    EmailAddress:"",
    DisplayNumber:"",
    IncomingNumber:"",
    ForwardToNumber:"",
    settingsTypeGateway:"",
    Settings : {"Type":"","ForwardToNumber":"","IncomingNumber":"",DisplayNumber:"","EmailAddress":"","OxygenNumber":""},
    window: null,
    windowHtml: `<p>Here is a neat and flexible JavaScript window system with a fast and simple initialization.</p><p>Inspect all the DHTMLX window samples to discover each and every feature.</p><img style='display: block; width: 200px; height: 200px; margin-top: 20px; margin-left: auto; margin-right: auto' src='https://dhtmlx.github.io/react-widgets/static/developer.svg'>`,
  }),
  mounted() {
  },
  computed:{
  },
  beforeDestroy() {
    if (this.window) {
      this.window.destructor();
    }
  },
  methods: {
    saveMeeting: function() {
      console.log("got meeting name",this.meetingName);
      window.DevMgr.setMeeting(document.getElementById('meetingName').value);
      this.popupshow = false;
    },
    showPopUp : function(client,viewport,  ore) {
      console.log("====phone number show pop up===="+client);
      this.clientID = client;
      //document.getElementById('setPhoneFrame').src = "/DeepLander-0086/CRMV2/ForwardSettings/ForwardSettings.html?clientID="+client;
      let url = "/DeepLander-0086/CRMV2/ForwardSettings/ForwardSettings.html?clientID="+client;
      this.windowHtml  = "<iframe height='auto' scrolling='no' iframeborder=0 width='100%' style='border:none;' src='"+url+"' ></iframe>";
      this.popupshow = true;
      
      this.window = new dhx.Window({
      width: "800",
      height: "auto",
      left:400,
      title: "Phone Number Settings",
      top: 25,
      html: this.windowHtml,
      closable: true,
    });

    this.window.show();
    },
    getSettings: function(event) {
      var data = event.target.value;
      console.log("getSettings",);
      window.BotServices.peSettings({Action : 'getSettings', Data : {Client: window.botStore.getClientByID(window.devStore.activeClient.ClientRowID),Type:data}}, (err, res) => {
        if(res) {
            console.log("get setti ngs result",res);
            let res1 = JSON.parse(res);
            let Result = res1.Result;
            this.Settings.settingsTypeGateway = data;
            this.Settings.ForwardToNumber = Result.ForwardNumber;
            this.Settings.IncomingNumber = Result.DID;
            this.Settings.DisplayNumber = Result.CallerID;
            this.Settings.EmailAddress = Result.Email;
            this.Settings.OxygenNumber = Result.OxygenNumber;
        }
      });
    },
    requestSettings: function() {
      console.log("got meeting name"+this.Settings.settingsTypeGateway+"==="+this.Settings.OxygenNumber,"========="+this.Settings.EmailAddress+"===="+this.Settings.DisplayNumber+"==="+this.Settings.IncomingNumber+"==="+this.Settings.ForwardToNumber);
      window.BotServices.peSettings({Action : 'requestSettings', Data : {Client: window.botStore.getClientByID(window.devStore.activeClient.ClientRowID),Type:this.Settings.settingsTypeGateway,Email:this.Settings.EmailAddress,DisplayNumber:this.Settings.DisplayNumber,IncomingNumber:this.Settings.IncomingNumber,ForwardToNumber:this.Settings.ForwardToNumber}}, (err, res) => {
          if(res) {
              console.log("request settings result",res);
          }
      });
    }
  }
}
</script>

<template>
    <div>
      <div ref="window"></div>
    </div>
  </template>

<style>
.label-text {
    padding: 0 0px;
    font-size: inherit;
    overflow: hidden;
    /*text-overflow: ellipsis;*/
    white-space: nowrap;
    font-family: Roboto,Arial,Tahoma,Verdana,sans-serif!important;
}
.input-text {
  background-color: white;
  border: 1px solid lightgray;
  width: 100%;
  display: block;
}
.ButtonText{
    margin-left: 145px;
    height: 25px;
    background-color: #0072c5;
    color: #fff;
    white-space: nowrap;
    align-items: center;
    font-family: Roboto,Arial,Tahoma,Verdana,sans-serif!important;
    width:50%;
}

formbox{
  max-width:460px;
  margin:auto;
  margin-top:35px;
  border:0px solid #2f2f2f;
  padding:24px;
  border-radius:4px;
}
#btn-submit{
  width:100%;
}
</style>
